var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AI"},[_c('InfoViewer',{attrs:{"top":10,"left":40,"width":20,"height":0,"stop":5,"sleft":20,"swidth":60,"sheight":0}}),_c('Button',{attrs:{"text":'ATRÁS',"styleType":4},on:{"click":_vm.goToServices}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }